module.exports = "<div [ngClass]=\"{'tap-top': showScroll}\" (click)=\"onActivate()\">\r\n  <div><i class=\"fa fa-angle-double-up\"></i></div>\r\n</div>\r\n"